import type { MessageAttachmentType } from "@/lib/endpoints";

/**
 * The i18n key that captions each kind of attached document.
 *
 * ═════════════════════════════════════════════════════════════════════════════
 * A MAP OF LITERAL KEYS RATHER THAN `t(\`chat.about.${type}\`)`, FOR TWO REASONS
 * THAT ARE BOTH ABOUT BEING CAUGHT WHEN IT IS WRONG.
 *
 *  1. `i18n-completeness.test.ts` SCANS THE SOURCE FOR `t("…")` — a literal, by
 *     regex, because that is the only form this codebase uses. A template key is
 *     invisible to it, so a `chat.about.*` string missing from `mr.json` would
 *     render the raw key on the OWNER'S screen (§11.4) and no test would notice.
 *     The keys are still not literals AT THE CALL SITE, which is why
 *     `__tests__/attachment-copy.test.ts` asserts every one of them exists in
 *     both locales — the check the scanner cannot do for us, done explicitly.
 *  2. IT IS A TOTAL `Record` OVER THE UNION, so a fifth document kind added to
 *     `MESSAGE_ATTACHMENT_TYPES` fails to COMPILE here rather than rendering
 *     `chat.about.purchaseOrder` at a reader.
 *
 * A template key would have had neither property, and would have looked tidier.
 * ═════════════════════════════════════════════════════════════════════════════
 */
export const ATTACHMENT_ABOUT_KEY: Readonly<Record<MessageAttachmentType, string>> = Object.freeze({
  invoice: "chat.about.invoice",
  quotation: "chat.about.quotation",
  challan: "chat.about.challan",
  creditNote: "chat.about.creditNote",
});
